<template>
  <v-card>
    <v-card-title>
      <span class="text-h5"
        >{{ $t('ITEM.ADD') }} {{ $t('RELATED_COMPANIES.ITEM') }}</span
      >
    </v-card-title>
    <v-card-text>
      <div v-if="error">
        <v-alert
          v-for="(e, index) in error.data.errors"
          :key="index"
          color="error"
          dark
          dense
        >
          {{ e[0] }}
        </v-alert>
      </div>

      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          :label="`${person.first_name} ${person.last_name}`"
          disabled
        ></v-text-field>

        <v-autocomplete
          v-model="relation.relatedId"
          :items="companies"
          :loading="!!!companies"
          :item-text="item => item.id + '. ' + item.name"
          item-value="id"
          :rules="rules.requiredSelectNotArray"
          :label="`${$t('RELATED_COMPANIES.ITEM')} *`"
        >
        </v-autocomplete>

        <v-autocomplete
          v-model="relation.relationshipId"
          :items="relationships"
          :loading="!!!relationships"
          item-value="id"
          item-text="name"
          :rules="rules.requiredSelectNotArray"
          :label="`${$t('RELATIONS.RELATIONSHIP')} *`"
        ></v-autocomplete>

        <v-switch v-model="relation.key" :label="`Key`"></v-switch>

        <v-textarea
          v-model="relation.notes"
          outlined
          counter="80"
          :rules="rules.textDescription80"
          :label="$t('RELATIONS.NOTES')"
        ></v-textarea>

        <v-autocomplete
          v-model="relation.priorityId"
          :items="prioritiesList"
          item-text="title"
          item-value="id"
          :rules="rules.requiredSelectNotArray"
          :label="`${$t('RELATIONS.PRIORITY')} *`"
        ></v-autocomplete>

        <v-container>
          <v-layout align-center justify-space-between row>
            <v-btn outlined text @click="$emit('cancel')">{{
              $t('BUTTON.CANCEL')
            }}</v-btn>
            <v-btn
              color="success"
              :disabled="!valid"
              :loading="loading"
              @click="validate"
            >
              {{ $t('BUTTON.CREATE') }}
            </v-btn>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  requiredSelectNotArray,
  textDescription80
} from '@/modules/_global/variables/rules.js';
import priority from '@/modules/relations/components/mixins/priority';

export default {
  name: 'RelationsCompanyCreate',

  mixins: [priority],

  props: {
    person: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    companies: [],

    relation: {
      key: false
    },
    error: null,
    valid: true,
    relationships: [],
    rules: { requiredSelectNotArray, textDescription80 }
  }),

  computed: {
    loading() {
      return this.$store.getters['loading'];
    }
  },

  created() {
    this.$store
      .dispatch('company/retrieveCompaniesByType', 3)
      .then(({ data }) => {
        this.companies = data;
      })
      .catch(error => {
        this.error = error.response;
      });

    this.$store
      .dispatch('relation/retrieveRelationshipsWithCompany')
      .then(response => {
        this.relationships = response.data;
      })
      .catch(error => {
        this.error = error.response;
      });
  },

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch('relation/store', {
            type: 'company',
            person_id: this.person.id,
            related_id: this.relation.relatedId,
            relationship_id: this.relation.relationshipId,
            key: this.relation.key,
            notes: this.relation.notes,
            priority: this.relation.priorityId
          })
          .then(({ data }) => {
            this.$store.commit('snackbar/setSnack', {
              status: 'success',
              text: this.$t('MESSAGE.SUCCESS')
            });
            this.$emit('success', data);
            this.$store.commit('loading', false);
          })
          .catch(error => {
            this.error = error.response;
            this.$store.commit('loading', false);
          });
      }
    }
  }
};
</script>
